import React from "react";
import Select from "react-select";

const CustomSelect = ({
  defaultValue,
  placeholder,
  options,
  onChange,
  customStyles,
  isSearchable = false,
  value,
  ...props
}) => {
  return (
    <Select
      placeholder={placeholder}
      styles={customStyles}
      value={value}
      defaultValue={defaultValue}
      options={options}
      onChange={onChange}
      isSearchable={isSearchable}
      {...props}
    />
  );
};

export default CustomSelect;
